import { FC } from 'react';
// components
import DuplicateSupplierComponent from 'components/main/Supplier/Duplicate';

const DuplicateSupplier: FC = () => <DuplicateSupplierComponent />;

export default DuplicateSupplier;
